import { useEmployeeById, useEmployees, useLoggedInEmployee } from "~Shared/hooks/employee.hooks"
import { mapEmployeeToUserCreditor } from "../utils/vendor.utils"

/*
 * CREDITOR-HOOKS
 */

export const useUserCreditorById = (creditorId: string | undefined) => {
    const employee = useEmployeeById(creditorId)

    return employee ? mapEmployeeToUserCreditor(employee) : undefined
}

export const useUserCreditors = (canSeeEveryEmployee: boolean) => {
    const employees = useEmployees({ excludeDeleted: true })
    const currentEmployee = useLoggedInEmployee()

    const userCreditors = employees.map(mapEmployeeToUserCreditor)
    return canSeeEveryEmployee ? userCreditors : [mapEmployeeToUserCreditor(currentEmployee)]
}
